"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACDateRangeSegments = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var dayjs_1 = __importDefault(require("dayjs"));
var localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
var weekday_1 = __importDefault(require("dayjs/plugin/weekday"));
var react_1 = require("react");
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(localeData_1.default);
var RangePicker = antd_1.DatePicker.RangePicker;
var ACDateRangeSegments = function (props) {
    var _a, _b;
    var today = (0, dayjs_1.default)();
    var dayRange = (0, react_1.useMemo)(function () { return [today, today]; }, [today]);
    var weekRange = (0, react_1.useMemo)(function () { return [today.subtract(6, 'days'), today]; }, [today]);
    var monthRange = (0, react_1.useMemo)(function () { return [today.subtract(29, 'days'), today]; }, [today]);
    var _c = (0, react_1.useState)((_a = props.defaultSegment) !== null && _a !== void 0 ? _a : 'TD'), segmentVal = _c[0], setSegmentVal = _c[1];
    var _d = (0, react_1.useState)(), dateValues = _d[0], setDateValues = _d[1];
    var _e = (0, react_1.useState)(true), rightLoading = _e[0], setRightLoading = _e[1];
    var _f = (0, react_1.useState)(true), leftLoading = _f[0], setLeftLoading = _f[1];
    (0, react_1.useEffect)(function () {
        setDateValues(function () {
            switch (props.defaultSegment) {
                case 'TD':
                    return dayRange;
                case 'TW':
                    return weekRange;
                case 'TM':
                    return monthRange;
                default:
                    return dayRange;
            }
        });
    }, [props === null || props === void 0 ? void 0 : props.defaultSegment]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        var isStartDateMissing = !((_a = dateValues === null || dateValues === void 0 ? void 0 : dateValues[0]) === null || _a === void 0 ? void 0 : _a.isValid());
        var isEndDateToday = ((_b = dateValues === null || dateValues === void 0 ? void 0 : dateValues[1]) === null || _b === void 0 ? void 0 : _b.format('DD-MM-YYYY')) === today.format('DD-MM-YYYY');
        setRightLoading(isStartDateMissing || isEndDateToday);
        setLeftLoading(isStartDateMissing);
        if (isStartDateMissing || !((_c = dateValues === null || dateValues === void 0 ? void 0 : dateValues[1]) === null || _c === void 0 ? void 0 : _c.isValid())) {
            setSegmentVal('');
        }
        else {
            var diff = (0, dayjs_1.default)(dateValues[1]).diff((0, dayjs_1.default)(dateValues[0]), 'days');
            var newSegment = diff === 0 ? 'TD' : diff === 6 ? 'TW' : diff === 29 ? 'TM' : '';
            setSegmentVal(newSegment);
        }
    }, [dateValues, today]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (props.value &&
            Array.isArray(props.value) &&
            props.value[0] &&
            props.value[1]) {
            var newVals = [
                (0, dayjs_1.default)(props.value[0], 'DD-MM-YYYY'),
                (0, dayjs_1.default)(props.value[1], 'DD-MM-YYYY'),
            ];
            var isSame = ((_a = dateValues === null || dateValues === void 0 ? void 0 : dateValues[0]) === null || _a === void 0 ? void 0 : _a.isSame(newVals[0], 'day')) &&
                ((_b = dateValues === null || dateValues === void 0 ? void 0 : dateValues[1]) === null || _b === void 0 ? void 0 : _b.isSame(newVals[1], 'day'));
            if (!isSame) {
                setDateValues(newVals);
            }
        }
    }, [props.value]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (dateValues) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, dateValues.map(function (d) { var _a; return (_a = d === null || d === void 0 ? void 0 : d.format('DD-MM-YYYY')) !== null && _a !== void 0 ? _a : null; }));
        }
    }, [dateValues, props.defaultSegment]);
    var handleChange = (0, react_1.useCallback)(function (dates) {
        if (dates) {
            // eslint-disable-next-line prefer-const
            var start = dates[0], end = dates[1];
            if (props.disabled !== false && start && (end === null || end === void 0 ? void 0 : end.isAfter(today))) {
                end = today;
            }
            setDateValues([start, end]);
        }
        else {
            setDateValues([null, null]);
        }
    }, [props.disabled, segmentVal, today]);
    var handleSegmentChange = (0, react_1.useCallback)(function (val) {
        var values = val === 'TD'
            ? dayRange
            : val === 'TW'
                ? weekRange
                : val === 'TM'
                    ? monthRange
                    : null;
        if (values) {
            setDateValues(values);
        }
    }, [dayRange, weekRange, monthRange]);
    var handleClick = (0, react_1.useCallback)(function (arrow) {
        if (!(dateValues === null || dateValues === void 0 ? void 0 : dateValues[0]) || !(dateValues === null || dateValues === void 0 ? void 0 : dateValues[1]))
            return;
        var diff = dateValues === null || dateValues === void 0 ? void 0 : dateValues[1].diff(dateValues === null || dateValues === void 0 ? void 0 : dateValues[0], 'days');
        var isSingleDay = diff === 0;
        var adjustDate = function (base, amount) {
            return props.enableAll || base.add(amount, 'days').isBefore(today)
                ? base.add(amount, 'days')
                : today;
        };
        var newStart;
        var newEnd;
        if (arrow === 'left') {
            newEnd = dateValues[0].subtract(1, 'day');
            newStart = isSingleDay ? newEnd : newEnd.subtract(diff, 'days');
        }
        else {
            newStart = adjustDate(dateValues[1], 1);
            newEnd = isSingleDay ? newStart : adjustDate(newStart, diff);
        }
        setDateValues([newStart, newEnd]);
    }, [dateValues, props.enableAll, today]);
    var disabledDate = (0, react_1.useCallback)(function (current) {
        if (props.enableAll)
            return false;
        if (props.weekrange)
            return current < today.subtract(7, 'd') || current > today;
        return current && current > today;
    }, [props.enableAll, props.weekrange, today]);
    var buttonElement = (0, react_1.useCallback)(function (icon, loading) { return ((0, jsx_runtime_1.jsx)("button", { onClick: function () { return handleClick(icon); }, className: "p-2 hover:bg-slate-100 hover:shadow-sm rounded-[4px] border-[1.5px] border-gray-300", disabled: !props.enableAll && loading, children: icon === 'left' ? ((0, jsx_runtime_1.jsx)("i", { className: "aci aci-left-arrow" })) : ((0, jsx_runtime_1.jsx)("i", { className: "aci aci-right-arrow" })) })); }, [handleClick, props.enableAll]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-1 ".concat(props.className), children: [(props === null || props === void 0 ? void 0 : props.segmentedOptions) && ((_b = props === null || props === void 0 ? void 0 : props.segmentedOptions) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((0, jsx_runtime_1.jsx)(antd_1.Segmented, { options: props.segmentedOptions.map(function (opt) { return ({
                    label: (0, jsx_runtime_1.jsx)(antd_1.Tooltip, { title: opt.tooltip, children: opt.label }),
                    value: opt.value,
                }); }), value: segmentVal, onChange: handleSegmentChange })), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [buttonElement('left', leftLoading), (0, jsx_runtime_1.jsx)(RangePicker, { value: dateValues, onChange: handleChange, disabledDate: disabledDate, format: "DD-MM-YYYY", allowClear: false, className: "apx-ui_date__picker !w-[250px]" }), buttonElement('right', rightLoading)] })] }));
};
exports.ACDateRangeSegments = ACDateRangeSegments;
